import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Footer from '../footer';
import {  useParams } from "react-router-dom";
import { UserProvider, useUser } from '../../context/UserContext'
import Svg from '../../static/user.svg'
import ApoyarCausa from './ApoyarCausa'
import BoxIntereses from './Intereses'
import { HashLink } from 'react-router-hash-link';
import SvgFB from '../../static/icon-fb-btn.svg';
import notImage from "../../static/not-image.jpg"; 

let NotLogin = function({ data }) {
  
  const { FBLogin } = useUser();
  
  let _default = {
    title: 'Apoya esta causa',
    description : 'Registrate con tu perfil de Facebook darle tu apoyo a esta causa y compartirlo entre tus amigos.'
  }
  
  Object.assign(_default, data);
  
  console.log(_default)
  
  return (
    <div className="notLogin">
      <div className="box banner">
        <h2>{_default.title}</h2>
        <p className="desc">{_default.description}</p>
        <a href="#" className="fb-btn" onClick={e => { e.preventDefault(); FBLogin();}}><img src={SvgFB} />Ingresar con Facebook</a> 
      </div>
      <ParaQue />
    </div>
  )
}

let ParaQue = function(){
  return (
    <div className="paraque">
      <h2 className="title">¿Para qué debo registrarme en Pulso?</h2>
      <ul>
        <li>Publicá tus propias Causas para buscar apoyo.</li>
        <li>Apoyá Causas que son importantes para vos.</li>
        <li>Descubrí Causas relacionadas a tus intereses.</li>
        <li>Encontrá causas cercanas a tu ubicación.</li>
        <li>Identificá Causas Apoyadas por personas parecidas a vos.</li>
      </ul>
    </div>
  )
}

export default function Causas() {
  let { id } = useParams();

  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin } = useUser();

  const [causa, setCausa] = useState({
    title : null,
    img : null,
    dirigido : null,
    desc: null
  });



  useEffect( () => {
    function fetchItems() {
      Axios.get(process.env.REACT_APP_API + '/api/v1/causa/' + id)
           .then( response => {
             setCausa(response.data);
           })
           .catch( e => {
             console.log(e);
           })
    }
    if(window.FB){
      window.FB.XFBML.parse();
    }

    fetchItems()
  },[login]);


  return (
    <section id="causas-ver">
      <div className="container">
        <h3>Causa de {causa.first_name} a : {causa.dirigido}</h3>
        <h1>{causa.title}</h1>
        <div className="main">
          <div className="content">
            <div className="header">
              <a className="active">Detalles de la causa</a>
              <HashLink to="#comentarios">Comentarios</HashLink>
            </div>

            <figure>
              <img src={ causa.img == '' || causa.img == null ? notImage : causa.img } />
            </figure>

            <div className="fecha">{causa.created_at}</div>

            <div className="body-content">
              {causa.desc}
            </div>

            <div className="fb-comments" data-numposts="10" data-width="100%" id="comentarios"></div>

          </div>
          
          <div className="nav">
          { usuario == null ? <NotLogin />: <ApoyarCausa data={id} /> } 
          { usuario == null ? null : <BoxIntereses data={id} /> }  
            
          </div>
        </div>
      </div>

    </section>
  )
}

export {NotLogin};

